import React, { useEffect, useState } from "react";
import BlogsCard from "../BlogsCard/BlogsCard";
import Heading from "../Heading/Heading";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);

  const fetchBlogs = async () => {
    try {
      await fetch("./blogs.json")
        .then((res) => res.json())
        .then((data) => setBlogs(data.blogs));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <div className="blogs mt-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <Heading title1="Blogs" title2="Recent Blogs" />
          </div>
          {blogs.map((blog) => (
            <BlogsCard key={blog.id} blog={blog} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blogs;
